interface TextLine {
  text: string;
  confidence?: number;
}
export interface OCRResult {
  text_lines: TextLine[];
  languages?: string[];
  image_bbox: number[];
}

export const POLYP_TYPES = [
  "Hyperplastic Polyp",
  "Sessile Serrated Polyp",
  "Tubular Adenoma",
  "Traditional Serrated Adenoma",
  "Tubulovillous or villous adenoma",
] as const;

export const LOCATIONS = [
  "Rectum",
  "Sigmoid Colon",
  "Descending Colon",
  "Transverse Colon",
  "Ascending Colon",
  "Cecum",
] as const;

export interface Polyp {
  polypType: (typeof POLYP_TYPES)[number];
  size: number;
  location: (typeof LOCATIONS)[number];
  dysplasia: boolean;
  piecemeal: boolean;
}

export interface RecommendationResponse {
  recommendation: string;
  emails: { [key: string]: string };
  context: string;
}
